
import { motion } from "framer-motion";
import { TiltedScroll } from "@/components/ui/tilted-scroll";

export const CostsSection = () => {
  const costsItems = [
    { id: "1", text: "70% faster development" },
    { id: "2", text: "60% cost reduction" },
    { id: "3", text: "AI-powered code quality" },
    { id: "4", text: "24/7 AI development cycles" },
    { id: "5", text: "Human-AI collaboration" },
    { id: "6", text: "Streamlined workflows" },
    { id: "7", text: "Real-time AI optimization" },
    { id: "8", text: "Self-improving systems" },
  ];

  return (
    <div className="relative min-h-screen flex flex-col items-center justify-center">
      <motion.h2 
        className="text-5xl sm:text-[10vw] leading-tight sm:leading-none font-display font-bold text-white relative z-10 text-center mb-16"
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8 }}
      >
        AI Reduces Dev Costs<br />by <span className="text-brand-orange">60%</span>
      </motion.h2>

      <motion.div 
        className="w-full flex justify-center"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 0.3 }}
      >
        <TiltedScroll items={costsItems} className="transform scale-125" />
      </motion.div>
    </div>
  );
};
